import {NgModule, Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'dictionaryTerms',
    standalone: false
})
export class DictionaryTermsPipe implements PipeTransform {

    transform(value: any, args: any): any {
        if (!args) {return value;}

        var specials = ['\\', '/', '^', '$', '!', '?', '(', ')', '{', '}', '[', ']', '|', '-', ':', '*', '+'];
        var specialsRegexp = new RegExp("(\\" + specials.join("|\\") + ")", "g");

        [].concat(args).forEach(term => {
            var termName = term['name'].replace(specialsRegexp, "\\$1");
            var regexp = new RegExp(`(${termName})+(?!(.(?!<ngx-dictionary-term))*<\/ngx-dictionary-term>)+(?!(.(?!<ignore-highlight))*<\/ignore-highlight>)`, 'is');
            value = value.replace(regexp, `<ngx-dictionary-term name="${term['name'].replace(/"/g, '&quot;')}" value="${term['value']}"></ngx-dictionary-term>`);
        });
        return value;
    }
}

@NgModule({
    declarations: [DictionaryTermsPipe],
    exports: [DictionaryTermsPipe]
})
export class DictionaryTermsPipeModule {}
